/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Open_TitleInputs */

const en_pc_tut_open_title = /** @type {(inputs: Pc_Tut_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open and read a PDF`)
};

const zh_pc_tut_open_title = /** @type {(inputs: Pc_Tut_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开并阅读 PDF`)
};

/**
* | output |
* | --- |
* | "Open and read a PDF" |
*
* @param {Pc_Tut_Open_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_open_title = /** @type {((inputs?: Pc_Tut_Open_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Open_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_open_title(inputs)
	return zh_pc_tut_open_title(inputs)
});
export { pc_tut_open_title as "pc.tut.open.title" }